import api from '../../../../services/CoreAPI';
import * as types from './action-types';
import _ from 'lodash';
import { UserService } from '../../../../services';

const FAILED_MESSAGE = 'Failed to succeed';

const selectOffer = (offerId) => ({
    asyncAction: (dispatch, getState) => {
        const deviceFingerprint = localStorage.getItem('blackboxId') || ';';
        return api.offers.select({ offerId, deviceFingerprint }).then((res) => {
            const { data } = res;
            UserService.set(
                { ...data.user, employmentStatus: data.employmentStatus, leadSource: data.leadSource }
            );
            window.dataLayer.push({
                event: 'LOAN_OFFER_SELECTED',
                loanId: data.user.loanId,
                underwritingCard: data.cardId,
            });
            return res;
        });
    },
    type: types.OFFER_SELECTING,
});

export default {
    FAILED_MESSAGE,
    selectOffer
};
